import { FunctionComponent } from 'react';
import styles from './LeadsIsEmpty.module.scss';

interface LeadsIsEmptyProps {
    title?: string;
    text?: string;
    onClick?: () => void;
}

const LeadsIsEmpty: FunctionComponent<LeadsIsEmptyProps> = ({
    title = 'No Leads Yet',
    text = 'Leads can be captured by adding them manually, sending an intake form, embedding a lead form on your website, receiving texts from unknown numbers, or from clients who abandon online booking.',
    onClick
}) => {
    return (
        <div className={styles.containerEmpty}>
            <img
                className={styles.imageEmpty}
                src="/images/memberships/clients-notfound.svg"
                alt="No leads found"
            />
            <h2 className={styles.titleEmpty}>{title}</h2>
            <div className={styles.descriptionEmptyContainer}>
                <p className={styles.descriptionEmpty}>{text}</p>
            </div>
        </div>
    );
};

export default LeadsIsEmpty;
